import { render, staticRenderFns } from "./CashStatementDetails.vue?vue&type=template&id=f4b0c856&scoped=true&"
import script from "./CashStatementDetails.vue?vue&type=script&lang=ts&"
export * from "./CashStatementDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CashStatementDetails.vue?vue&type=style&index=0&id=f4b0c856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b0c856",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardText,VCol,VDivider,VIcon,VRow,VTooltip})
